import * as React from 'react';
import { createPortal } from 'react-dom';
import { noPanoramaIcon } from './icon';
import * as styles from './NoPanorama.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NoPanorama = function NoPanorama(_ref) {
  var onClick = _ref.onClick,
    isFullscreen = _ref.isFullscreen;
  var content = /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [noPanoramaIcon, /*#__PURE__*/_jsx("div", {
      className: styles['title'],
      children: "\u041F\u0430\u043D\u043E\u0440\u0430\u043C\u044B \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442"
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['text'],
      children: ["\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u043F\u0430\u043D\u043E\u0440\u0430\u043C\u044B \u0443\u043B\u0438\u0446 \u0434\u043B\u044F \u044D\u0442\u043E\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438 \u043A\u0430\u0440\u0442\u044B", /*#__PURE__*/_jsx("br", {}), "\u043F\u043E\u043A\u0430 \u0447\u0442\u043E \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u044E\u0442"]
    }), /*#__PURE__*/_jsx("div", {
      className: styles['button'],
      onClick: onClick,
      children: "\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043A\u0430\u0440\u0442\u0443"
    })]
  });
  return isFullscreen ? /*#__PURE__*/createPortal( /*#__PURE__*/_jsx("div", {
    className: styles['fullscreenContainer'],
    children: content
  }), document.body) : content;
};